import type { StoreApi, UseBoundStore } from "zustand";

import type {
  SessionState,
  SessionStore,
  SessionStoreConfig,
  StoreSelectors,
} from "../../zustand/index.ts";
import { createSessionStore } from "../../zustand/index.ts";

interface AuthSessionStoreResult {
  readonly authSessionSelectors: StoreSelectors<SessionState>;
  readonly authSessionStore: SessionStore;
  readonly useAuthSessionStore: UseBoundStore<StoreApi<SessionStore>>;
}

export function createAuthSessionStore(
  config: SessionStoreConfig,
): AuthSessionStoreResult {
  const { sessionSelectors, sessionStore, useSessionStore } =
    createSessionStore(config);

  return {
    authSessionSelectors: sessionSelectors,
    authSessionStore: sessionStore,
    useAuthSessionStore: useSessionStore,
  };
}
